import type { Profile } from "../types";

export function sanitizeProfileForPersistence(profile: Profile): Profile {
	return profile;
}

export function sanitizeProfilesForPersistence(profiles: Profile[]): Profile[] {
	return profiles.map(sanitizeProfileForPersistence);
}
